export default __webpack_public_path__ + "static/media/symbl.752faa65.png";